<template>
  <div :class="paymentScreen ? '' : 'pb-12'">
    <v-row no-gutters>
      <v-col
        id="participants"
        :class="!$vuetify.breakpoint.mdAndUp && !paymentScreen ? 'px-6' : ''"
        :order="$vuetify.breakpoint.mdAndUp ? '0' : '1'"
        :cols="
          $vuetify.breakpoint.mdAndUp && !$route.query.embed && !paymentScreen
            ? '8'
            : '12'
        "
      >
        <Nomination :paymentScreen="paymentScreen" />
      </v-col>
      <v-col
        v-if="!paymentScreen && !$route.query.embed"
        :style="$vuetify.breakpoint.mdAndUp ? '' : 'background-color: #eee;'"
        :order="$vuetify.breakpoint.mdAndUp ? '1' : '0'"
        :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
      >
        <Summary style="position: sticky; top: 65px" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Summary from "../components/summary/Index.vue";
import Nomination from "../components/participants/nomination/Index.vue";
import { mapGetters } from "vuex";
export default {
  props: ["paymentScreen"],
  components: { Summary, Nomination },
  computed: {
    ...mapGetters(["orderDetails", "eventId"]),
  },
  async mounted() {
    let storage = await JSON.parse(
      localStorage.getItem(`cart-order-route-${this.eventId}`)
    );
    if (!this.orderDetails && !storage)
      this.$router.push({
        name: "Cart",
        params: { event: this.eventId },
        query: this.$route.query,
      });
    this.handleScrollTo(
      "#participants",
      this.$vuetify.breakpoint.mdAndUp ? -64 : -40
    );
  },
  methods: {
    handleScrollTo(element, ofs) {
      this.$scrollTo(element, 500, {
        offset: ofs,
      });
    },
  },
};
</script>
